// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "http://35.206.194.203:5040";
// export const BASE_URL = "https://3f5e1ad9d5eb.ngrok-free.app";

// export const BASE_URL = "https://api.educareit.com:6025";
// export const BASE_URL = "https://api.chatbot-world.com:6040";  //prod 2

export const BASE_URL = "https://api.quantumaisystems.com:6040";  // fast api

// export const BASE_URL = "https://api.chatbot-world.com:6010";
// export const BASE_URL = "https://api.chatbot-world.com:6020";

// export const BASE_URL = "http://35.206.245.118:5020"
// export const BASE_URL = "https://api.quantumaisystems.com:6008"
export const WS_URL = BASE_URL.replace(/^http/, 'ws').replace(/^https/, 'wss');

// Helper function to get WebSocket URL
export const getWebSocketUrl = () => {
  return `${WS_URL}/ws/status`;
};
